// Pagina nomina sin contenido

import React from 'react';
import { useUser } from '../UserContext';
import { Box, Typography } from '@mui/material';
import PayrollView from '../components/PayrollView';

export default function Payroll() {
  const { user, setUser } = useUser();

  return (
    <section>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">Nomina</Typography>
      </Box>
      <PayrollView />
    </section>
  );
}
